import config from './config';

declare global {
  let __webpack_public_path__: string;
}

__webpack_public_path__ = config.publicPath;
